import $ from 'jquery'
import ManageSection from '@/views/parametres/configs/param-fiche-medical/manage-section'
import ManageFicheConsultation from '@/views/parametres/configs/param-fiche-medical/manage-fiche-consultation' 
import store_fiche from "@/store/mods/consultations/fiche-consultations"

export default {
    name: 'liste-sections',
    components: {
        ManageSection, ManageFicheConsultation
    },
    props: {
        selected_consultation: Object,
        selected_fiche: Object,
        liste_autre_consultations: Array,
        info_user: Object,
        activeRole: Object
    },
    data() {
        return {
            fields: [
				'section', { key: 'etat', label: 'État' },  { key: 'actions', label: 'Action.s' }
			],
			filter_section: "",
			perPage: -1,
			currentPage: 1,

            section_loading: true,
            section_empty: false,
            liste_sections: [],
            modal_toggler: 0,
            section_to_edit: {},
            edit_modal_toggler: 0
        }
    },

    computed: {
        fiche_standard() {
            return (this.selected_fiche || {}).type_consultation_id == null
        },
        sections_visibles() {
            return this.fiche_standard
                ? this.liste_sections.filter(section => Number(section.etat) === 1)
                : this.liste_sections
        },
        default_consultation_sections(){
            return this.$store.getters["default_consultation_sections"];
        },
    },

    mounted() {
        this.listeSectionFicheByTypeConsultation()
    },

    methods: {
        libelleSection(section) {
            return this.fiche_standard && section.section === 'Anamnèse'
                ? 'Histoire de la maladie' : section.section
        },
        listeDefaultConsultationSection() {
            this.section_loading = true
            let data = {
                is_default: 1,
                can_show: 0
            }
            this.$store.dispatch('getDefaultConsultationSections', data).then(() => {
                if (this.default_consultation_sections.length == 0) {
                    this.section_empty = true
                } else {
                    this.section_empty = false
                }

                this.section_loading = false
            })
        },

        listeSectionFicheByTypeConsultation() {
            this.section_loading = true
            let data = {
                type_consultation_id: this.selected_consultation.id,
                fiche_consultation_id: this.selected_fiche.id
            }
            store_fiche.getSectionByTypeConsultation(data).then((sections) => {
                this.liste_sections = sections
                if (sections.length == 0) {
                    this.section_empty = true
                } else {
                    this.section_empty = false
                }

                this.section_loading = false
            })
        },

        goToPage(goto_page) {
            this.$emit('emitGoToPage', goto_page)
        },

        editFiche() {
            this.modal_toggler = (this.modal_toggler == 0)?1:0

            $('.add-fiche').modal('show')
        },

        viewFields(data) {
            this.goToPage('liste_champs')
            this.$emit('emitSetSection', data)
        },

        setSectionToEdit(data) {
            this.edit_modal_toggler = (this.edit_modal_toggler == 0)?1:0
            this.section_to_edit = data
            $('.edit-section').modal('show')
        }, 

        orderSection() {
            this.edit_modal_toggler = (this.edit_modal_toggler == 0)?1:0
            $('.order-evolution').modal('show')
        }
    }
}
